<div class="addNewPolicyContainer">
  <div class="Loading" *ngIf="isShowLoading==true">
    <img id="" src="assets/img/762.gif" />
    <label>{{'Please Wait,Processing..'|translate }}</label>
  </div>


  <div class="Clears"></div>
</div>



<div class="container-fluid">

  <div class="col-lg-5 col-md-5 hidden-sm hidden-xs">
    <div class="car_bg">
      <div class="Description">
        <img src="assets\img\3.png">
        <h3>{{'MEDICAL MALPRACTICE INSURANCE'|translate}}</h3>
        <div class="row" style="display: flex;justify-content:center;">
          <span *ngIf="Lng=='en'" class="glyphicon glyphicon-question-sign field-tip-logo">
            <span class="tip-content" [innerHTML]="MedMalLogoTooltip"></span>
          </span>
          <span *ngIf="Lng=='ar'" class="glyphicon glyphicon-question-sign field-tip-logoAr">
            <span class="tip-contentAr" [innerHTML]="MedMalLogoTooltip"></span>
          </span>
        </div>
      </div>
      <i class="fa fa-angle-right arrows"></i>
    </div>
  </div>

  <div class="col-lg-7 col-md-7 col-sm-12 col-xs-12">



    <form #NewMedmalPolicyConfirmForm="ngForm">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <div class="ClaimsHistoryGrid">
          <div class="panel panel-default panel-table">
            <div class="panel-heading">
              <div class="row">
                <div class="col col-xs-6">
                  <h3 class="panel-title">{{'Covers Info'|translate}}</h3>
                </div>
                <div class="col col-xs-6 text-right">

                </div>
              </div>
            </div>
            <div class="panel-body">
              <table class="table table-striped table-bordered table-list" style="margin-bottom: 0px;">
                <thead>
                  <tr>
                    <th>{{'SNo'|translate}}</th>
                    <th>{{'Cover Description'|translate}}</th>
                    <th>{{'Premium'|translate}}</th>
                    <th>{{'MedSum Insured'|translate}}</th>
                  </tr>

                </thead>
                <tbody>
                  <tr *ngFor="let cover of proposalObj.Covers;let i=index;">

                    <td>{{i+1}}</td>
                    <td *ngIf="Lng=='en'">{{ cover.CoverDescriptionEn }}</td>
                    <td *ngIf="Lng=='ar'">{{ cover.CoverDescriptionAr }}</td>
                    <td>{{ cover.GrossAmount | number : '1.2-2' }}</td>
                    <td>{{ cover.SumInsured | number : '1.2-2' }}</td>
                  </tr>
                </tbody>
              </table>

              <div>

              </div>
            </div>

          </div>
        </div>
      </div>
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <div class="panel panel-default panel-table">
          <div class="panel-heading">
            <div class="row">
              <div class="col col-xs-6">
                <h3 class="panel-title">{{'Premium Info in SAR'|translate}}</h3>
              </div>
              <div class="col col-xs-6 text-right">

              </div>
            </div>
          </div>
          <div class="panel-body">
            <table class="table table-striped table-bordered table-list">

              <tbody style="position: relative;">
                <!-- <tr>
            <td></td>
            <td class="text-right">{{'Gross Premium'|translate}}</td>
            <td>{{proposalObj.Grosspremium | number : '1.2-2' }}</td>
          </tr> -->

                <!-- <tr>
            <td></td>
            <td class="text-right">{{'Discount'|translate}}</td>
            <td>{{proposalObj.DiscountAmount | number : '1.2-2' }}
              ({{proposalObj.DiscountPercentage}}%)
            </td>
          </tr> -->

                <!-- <tr>
            <td></td>
            <td class="text-right">{{'CrossSell Discount'|translate}}</td>
            <td>{{proposalObj.CrossSellDiscountAmt | number : '1.2-2' }}
              ({{proposalObj.CrossSellDiscountPer}}%)
            </td>
          </tr> -->

                <!-- <tr>
            <td></td>
            <td class="text-right">{{'PromoDiscount'|translate}}</td>
            <td>{{proposalObj.PromoDiscount | number : '1.2-2'}}({{proposalObj.PromoDiscountPer}}%)</td>
          </tr> -->

                <tr>

                  <td class="text-right">{{'Total Premium(Excluding VAT)'|translate}}</td>
                  <td>{{ proposalObj.BeforeVATPremium | number : '1.2-2' }}</td>
                </tr>
                <tr>

                  <td class="text-right">{{'VAT Amount'|translate}}</td>
                  <td>{{ proposalObj.VATAmount | number : '1.2-2' }}
                    ({{proposalObj.VATPercent}}%)
                  </td>
                </tr>

                <tr *ngIf="proposalObj.UPRVAT>0">

                  <td class="text-right">{{'UPR VAT Amount'|translate}}</td>
                  <td>{{ proposalObj.UPRVAT | number : '1.2-2' }}</td>
                </tr>
                <tr>

                <tr>

                  <td class="text-right">{{'Total Premium'|translate}}</td>
                  <td style="color:red;font-weight:bold">{{ proposalObj.TotalPremium | number : '1.2-2' }}</td>
                </tr>

                <tr>
                  <td class="text-right"></td>
                  <td data-toggle="modal" data-target="#DetailedPremInfo" style="color: green;text-decoration: underline;cursor: pointer;">{{'Premium Breakdown'|translate}}</td>
                </tr>
              </tbody>

            </table>


            <div class="row">
              <div class="col-md-4 text-right">{{'Promo Code'|translate}}</div>
              <div class="col-md-4"><input type="text" class="form-control col-md-4" id="promoid" name="promoid" [(ngModel)]="proposalObj.PromoCode" [disabled]="IsPromoApplied==true" /></div>
              <div class="col-md-4"><button class="btn btn-primary" id="btnApply" name="btnApply" (click)="ApplyPromo()" [disabled]="IsPromoApplied==true ||(proposalObj.PromoCode==null ||proposalObj.PromoCode=='')">{{'Apply'|translate}}</button>
              </div>
            </div>


          </div>
        </div>

      </div>
    </form>

    <div class="Actionsection">
      <div class="ButtonActions">
        <div class="btn-group">
          <button type="button" name="txtCancel" id="txtCancel" class="btn btn-primary btns" (click)="CancelProceed()">{{'Prev'|translate}}</button>
          <button type="button" name="txtBUY" id="txtBUY" class="btn btn-primary btns" [disabled]="isError" (click)="Proceed()">{{'Next'|translate}}</button>
        </div>
      </div>
    </div>


  </div>

</div>


<div class="modal fade" id="DetailedPremInfo" role="dialog">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal">&times;</button>
        <h4 class="modal-title logins">{{'Detail Premium Breakdown'| translate}}</h4>
      </div>
      <div class="modal-body">
        <table class="table table-striped tabledesign">
          <tbody>
            <tr>
              <td>{{'Basic Premium'|translate}}</td>
              <td>{{proposalObj.BasicPremium | number : '1.2-2' }}</td>
            </tr>

            <tr *ngIf="proposalObj.RetroDateLoadAmt>0">
              <td>{{'RetroActiveDate Loading'|translate}}</td>
              <td>{{proposalObj.RetroDateLoadAmt | number : '1.2-2' }} ({{proposalObj.RetroDateLoadPer}}%)</td>
            </tr>

            <tr *ngIf="proposalObj.AddRetroDateLoadAmt>0">
              <td>{{'Additional RetroActiveDate Loading'|translate}}</td>
              <td>{{proposalObj.AddRetroDateLoadAmt | number : '1.2-2' }} ({{proposalObj.AddRetroDateLoadPer}}%)</td>
            </tr>

            <tr *ngIf="proposalObj.ExtPeriodLoadAmt>0">
              <td>{{'ExtendedPeriod Loading'|translate}}</td>
              <td>{{proposalObj.ExtPeriodLoadAmt | number : '1.2-2' }} ({{proposalObj.ExtPeriodLoadPer}}%)</td>
            </tr>

            <tr>
              <td>{{'DeductableDiscount'|translate}}</td>
              <td>{{proposalObj.DeductableLoadAmt | number : '1.2-2' }} ({{proposalObj.DeductableLoadPer}}%)</td>
            </tr>

            <tr>
              <td>{{'GrossPremium'|translate}}</td>
              <td>{{proposalObj.Grosspremium | number : '1.2-2' }}</td>
            </tr>

            <tr *ngIf="proposalObj.DiscountAmount>0">
              <td>{{'Discount'|translate}}</td>
              <td>{{proposalObj.DiscountAmount | number : '1.2-2' }} ({{proposalObj.DiscountPercentage}}%)</td>
            </tr>

            <tr *ngIf="proposalObj.CrossSellDiscountAmt>0">
              <td>{{'Cross Sell Discount'|translate}}</td>
              <td>{{proposalObj.CrossSellDiscountAmt | number : '1.2-2' }} ({{proposalObj.CrossSellDiscountPer}}%)</td>
            </tr>

            <tr *ngIf="proposalObj.PromoDiscount>0">
              <td>{{'Promo Discount'|translate}}</td>
              <td>{{proposalObj.PromoDiscount | number : '1.2-2' }} ({{proposalObj.PromoDiscountPer}}%)</td>
            </tr>

            <tr>
              <td>{{'Total Premium(Excluding VAT)'|translate}}</td>
              <td>{{proposalObj.BeforeVATPremium | number : '1.2-2' }} </td>
            </tr>

            <tr>
              <td>{{'VAT Amount'|translate}}</td>
              <td>{{proposalObj.VATAmount | number : '1.2-2' }} ({{proposalObj.VATPercent}}%)</td>
            </tr>

            <tr *ngIf="proposalObj.UPRVAT>0">
              <td>{{'UPR VAT Amount'|translate}}</td>
              <td>{{proposalObj.UPRVAT | number : '1.2-2' }} </td>
            </tr>

            <tr>
              <td>{{'Total Premium'|translate}}</td>
              <td style="color:red;font-weight:bold">{{proposalObj.TotalPremium | number : '1.2-2' }} </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<div class="PayMethods">
  <img src="assets/img/payment-footer-en1.png">
</div>


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/MedmalPortal/MedmalNewProposalConfirm/MedmalNewProposalConfirm.html